import moment from 'moment';
import localStorage from 'r/utils/localStorage';
import {SENTRY_LOG as localStorageKey} from '../KEYS';

export const metamask_header_not_found = 'metamask_header_not_found';
export const long_pooling_fetch_api_failed_to_fetch = 'long_pooling_fetch_api_failed_to_fetch';
export const san_api_failed_to_fetch = 'san_api_failed_to_fetch';
export const san_api_server_error = 'san_api_server_error';
export const vm_execution_error = 'vm_execution_error';
export const run_out_of_gas = 'run_out_of_gas';

const supported = [
  metamask_header_not_found,
  long_pooling_fetch_api_failed_to_fetch,
  san_api_failed_to_fetch,
  san_api_server_error,
  vm_execution_error,
  run_out_of_gas,
];

const stored = JSON.parse(localStorage.getItem(localStorageKey)) || {};

export default class StoredSentryLog {
  static get(id) {
    if (!supported.includes(id)) {
      throw new Error(`Wrong id ${id}`);
    }
    return stored[id];
  }

  static add(id) {
    if (!supported.includes(id)) {
      throw new Error(`Wrong id ${id}`);
    }
    stored[id] = moment().utc();
    localStorage.setItem(localStorageKey, JSON.stringify(stored));
  }
}
